var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "服务器列表"
    }
  }, [_c("server-list", {
    attrs: {
      readCacheType: 1,
      multiple: true
    },
    model: {
      value: _vm.searchInfo.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "server_id", $$v);
      },
      expression: "searchInfo.server_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "查看前n名："
    }
  }, [_c("el-input", {
    staticStyle: {
      width: "120px"
    },
    attrs: {
      placeholder: "输入前多少名"
    },
    model: {
      value: _vm.inputNum,
      callback: function callback($$v) {
        _vm.inputNum = $$v;
      },
      expression: "inputNum"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.checkPage();
      }
    }
  }, [_vm._v("点击查看")])], 1)], 1)], 1), _c("div", [[_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      height: "400",
      border: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      type: "index",
      width: "50",
      label: "排名"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "openId",
      label: "账号",
      width: "180"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "roleId",
      label: "角色Id"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "roleName",
      label: "角色名"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "serverId",
      label: "区服",
      width: "200"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "roleLevel",
      label: "等级",
      width: "100"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "totalRmb",
      label: "充值金额"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "createRoleTime",
      label: "注册时间",
      width: "200"
    }
  }), _c("el-table-column", {
    attrs: {
      prop: "lastLoginTime",
      label: "最后登录时间",
      width: "200"
    }
  })], 1)]], 2)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };